import { Link, useRouteError } from 'react-router-dom'

export default function NotFoundPage() {
  const error = useRouteError() as { statusText?: string; message?: string } | undefined

  return (
    <section className="section min-h-screen flex items-center justify-center bg-neutral-50">
      <div className="text-center max-w-md">
        <p className="text-8xl font-bold text-primary-100 select-none font-heading">404</p>
        <h1 className="text-2xl font-heading font-semibold mt-4 text-primary-DEFAULT">
          Seite nicht gefunden
        </h1>
        <p className="text-neutral-500 mt-2 text-sm">
          {error?.statusText ?? error?.message ?? 'Die gesuchte Seite existiert leider nicht.'}
        </p>
        <Link to="/" className="btn-primary mt-8 inline-block">
          Zur Startseite
        </Link>
      </div>
    </section>
  )
}
